import React, { Component } from "react";
import { Fade } from "react-reveal";
import ActionButton from "./Subcomponents/ActionButton/ActionButton";
import ModalContainer from "./Subcomponents/ModalContainer/ModalContainer";
import { isCompleted, setCompleted, getCurrentSurvey } from "./../Helpers/Storage";
import "./AppContainer.css";

const completeSurvey = (config) => {
  console.debug("completeSurvey");
  if (config.tag.keep_alive_after_completion) {
    return;
  }
  setCompleted();
  if (config.tag.survey_id && config.tag.survey_id.toString() === getCurrentSurvey()) {
    delete config.tag.survey_id;
    document.dispatchEvent(new Event("chatter-reset-chat"));
    setCompleted();
  } else {
    document.dispatchEvent(new Event("chatter-reset-chat"));
    config.tag.manually_triggered_survey_id = undefined;
  }
};

const triggerOnMinimizeEvent = () => {
  document.dispatchEvent(new Event("chatter-survey-minimized"));
};

const triggerOnCloseEvent = () => {
  document.dispatchEvent(new Event("chatter-survey-closed"));
};

const AppContainer = ({ config }) => {
  const [isExpanded, setIsExpandedState] = React.useState(false);
  const [isConfirmed, setIsConfirmed] = React.useState(false);
  const isExpandedRef = React.useRef(isExpanded);
  const setIsExpanded = data => {
    isExpandedRef.current = data;
    setIsExpandedState(data);
  };

  React.useEffect(() => {
    document.addEventListener("chatter-show-survey", function() {
      setIsExpanded(true);
      setIsConfirmed(config.tag.skip_opt_in_window != undefined ? !!config.tag.skip_opt_in_window : true);
    }, false);
    document.addEventListener("chatter-hide-survey", function() {
      setIsExpanded(false);
    }, false);
    document.addEventListener("chatter-toggle-survey", function() {
      const expand = !isExpandedRef.current;
      setIsExpanded(expand);
      if (expand) {
        setIsConfirmed(config.tag.skip_opt_in_window != undefined ? !!config.tag.skip_opt_in_window : true);
      }
    }, false);
    document.addEventListener("chatter-open-conversation", function(e) {
      if (!!e.surveyId && !isCompleted(e.surveyId)) {
        document.dispatchEvent(new Event("chatter-reset-chat"));
        config.tag.manually_triggered_survey_id = e.surveyId;
        setIsExpanded(true);
        setIsConfirmed(true);
      }
    });
  }, []);

  const handleOpenChat = () => {
    config.tag.manually_triggered_survey_id = undefined;
    setIsConfirmed(true);
  };

  return (
    <div className="chatter-chat-box">
      <Fade bottom when={isExpanded} duration={500}>
        <div
          className={`${!!config.tag.fullScreen ? "full-screen-container" : "bottom-right-container"} ${isExpanded ? "very-top" : "very-bottom"}`}
        >
          <ModalContainer
            isConfirmed={isConfirmed}
            onClick={e => e.stopPropagation()}
            onOpen={handleOpenChat}
            onClose={() => { setIsExpanded(false); setIsConfirmed(false); completeSurvey(config); triggerOnCloseEvent(); }}
            onMinimize={() => { setIsExpanded(false); setIsConfirmed(false); triggerOnMinimizeEvent(); }}
            config={config}
          />
        </div>
      </Fade>
      {!isExpanded && !config.tag.hide_stock_button && config.tag.survey_id && (
        <ActionButton
          text={config.text ? config.text.ctaText || "Give feedback" : "Give feedback"}
          onClick={() => { setIsExpanded(true); setIsConfirmed(config.tag.skip_opt_in_window != undefined ? !!config.tag.skip_opt_in_window : true); }}
        />
      )}
    </div>
  );
};

export default AppContainer;
